import { BaseContainerModel } from '../../base-container.model';
import { bl_b2b_payment_request_stmt_hdr_RowClass, bl_b2b_payment_request_stmt_line_RowClass} from '../../../dbschema';

export class PaymentStatementContainerModel extends BaseContainerModel {
    bl_b2b_payment_request_stmt_hdr: bl_b2b_payment_request_stmt_hdr_RowClass = new bl_b2b_payment_request_stmt_hdr_RowClass();
    bl_b2b_payment_request_stmt_lines: bl_b2b_payment_request_stmt_line_RowClass[] = []
}